import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Switch, Route} from 'react-router-dom';
import Navbar from './components/Navbar';
import ProductList from "./components/ProductList";
import Default from './components/Default';
import Cart from './components/Cart/Cart';
import Details from './components/Details';
import Modal from './components/Modal';

class App extends Component {
  render () {
    return (
      <React.Fragment>
       <Navbar />
       <Switch>
         <Route exact path="/" component={ProductList} />
         <Route path="/details" component={Details} />
         <Route path="/cart" component={Cart} />
         <Route component={Default} />
       </Switch>
       <Modal />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js